var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('section', {
    ref: "sidebar",
    staticClass: "app-sidebar",
    class: {
      'sidebar-hidden': !_setup.isSidebarOpen
    }
  }, [_c('nav', {
    staticClass: "sidebar sidebar-offcanvas d-flex flex-column",
    attrs: {
      "id": "sidebar"
    }
  }, [_setup.isCompanySidebar || _setup.isProfileSidebar || _setup.isMasterDataSidebar ? _c('div', {
    staticClass: "nav d-block overflow-hidden pb-0 sidebar-block-container sidebar-back-container flex-shrink-0"
  }, [_c('b-button', {
    staticClass: "back-btn nav-link",
    attrs: {
      "variant": "link",
      "block": "",
      "aria-label": _vm.$t('button.back.label')
    },
    on: {
      "click": _setup.goBack
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "menu-icon"
  }, [_c('svg-icon', {
    staticClass: "back-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "name": "arrow-left",
      "size": "20",
      "variant": "primary",
      "aria-hidden": "true"
    }
  })], 1), _c('span', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('button.back.label')))])])])], 1) : _vm._e(), _c('div', {
    staticClass: "sidebar-items-container flex-grow-1 sidebar-block-container"
  }, _vm._l(_setup.groupedSidebarItems, function (items, key) {
    return _c('ul', {
      key: key,
      staticClass: "nav"
    }, _vm._l(items, function (item) {
      return _c('li', {
        key: item.$ID,
        staticClass: "nav-item menu-items",
        class: {
          dropdown: item.Items
        }
      }, [item.Items ? _c('SidebarGroupsItem', {
        attrs: {
          "id": item.$ID,
          "title": _vm.$t(item.Caption),
          "icon": item.Icon,
          "show-lock": item.showLock,
          "icon-class": item.IconClass,
          "view-box": item.ViewBox,
          "children": item.Items
        }
      }) : _c('SidebarSimpleItem', {
        attrs: {
          "id": item.$ID,
          "title": _vm.$t(item.Caption),
          "icon": item.Icon,
          "icon-class": item.IconClass,
          "show-lock": item.showLock,
          "ability": item.ability,
          "view-box": item.ViewBox,
          "router-to": {
            name: item.Action.Page
          }
        },
        on: {
          "click": _setup.collapseAll
        }
      })], 1);
    }), 0);
  }), 0), _setup.isMainSidebar ? _c('ul', {
    staticClass: "nav pb-0"
  }, [_c('li', {
    staticClass: "nav-item menu-items"
  }, [_c('SidebarSimpleItem', {
    attrs: {
      "id": "Apps",
      "title": _vm.$t('sidebar.titles.apps'),
      "icon": "grid-view",
      "icon-class": "fill-icon",
      "view-box": "0 0 24 24",
      "router-to": {
        name: 'Apps'
      }
    },
    on: {
      "click": _setup.collapseAll
    }
  })], 1), _c('SidebarChangeTypeItem', {
    attrs: {
      "icon": "hard-drive",
      "viewBox": "0 0 20 20",
      "iconClass": "fill-icon",
      "title": _vm.$t('sidebar.titles.masterData')
    },
    nativeOn: {
      "click": function ($event) {
        return _setup.goToMasterData.apply(null, arguments);
      }
    }
  }), _c('SidebarChangeTypeItem', {
    attrs: {
      "icon": "settings",
      "title": _vm.$t('sidebar.titles.companySettings')
    },
    nativeOn: {
      "click": function ($event) {
        return _setup.goToCompanySettings.apply(null, arguments);
      }
    }
  })], 1) : _vm._e(), _setup.isAuthenticated ? _c('div', {
    staticClass: "dropdown-container"
  }, [_c('b-dropdown', {
    ref: "profileDropdown",
    staticClass: "profile-dropdown",
    attrs: {
      "id": "profileDropdown",
      "dropright": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('div', {
          staticClass: "user-container d-flex align-items-center"
        }, [_c('div', [_setup.userPhoto ? _c('div', [_c('img', {
          staticClass: "img-xs rounded-circle",
          attrs: {
            "src": _setup.userPhoto,
            "alt": "user-photo"
          }
        })]) : _c('div', {}, [_c(_setup.defaultPhotoSmall)], 1)]), _c('div', {
          staticClass: "user-info"
        }, [_c('div', {
          staticClass: "sidebar-profile"
        }, [_c('div', {
          staticClass: "display-2 sidebar-profile-name text-white"
        }, [_vm._v(" " + _vm._s(_setup.userName) + " ")]), _c('div', {
          staticClass: "caption text-muted text-left"
        }, [_vm._v(" " + _vm._s(_setup.userRoleValue) + " ")])])])])];
      },
      proxy: true
    }], null, false, 3628948942)
  }, [_c('SidebarProfileDropdownBody', {
    attrs: {
      "userPhoto": _setup.userPhoto,
      "userRole": _setup.userRoleValue,
      "userName": _setup.userName
    },
    on: {
      "chooseProfileItem": function ($event) {
        return _setup.setSidebarType(_setup.sidebarTypes.PROFILE);
      }
    },
    scopedSlots: _vm._u([{
      key: "locale-dropdown",
      fn: function () {
        return [_c('div', {
          staticClass: "locale-container"
        }, [_c('b-dropdown', {
          ref: "localeDropdown",
          staticClass: "locale-dropdown",
          attrs: {
            "id": "localeDropdown",
            "no-flip": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function () {
              return [_c('div', {
                staticClass: "d-flex align-items-center justify-content-between"
              }, [_c('div', {
                staticClass: "d-flex align-items-center"
              }, [_c('svg-icon', {
                attrs: {
                  "viewBox": "0 0 20 20",
                  "name": "language",
                  "size": "20"
                }
              }), _c('div', {
                staticClass: "ml-3 display-2 text-muted"
              }, [_vm._v(" " + _vm._s(_vm.$t('languagesName')) + " ")])], 1), _c('div', [_c('svg-icon', {
                staticClass: "chevron",
                attrs: {
                  "size": "20",
                  "viewBox": "0 0 20 20",
                  "name": "chevron-right"
                }
              })], 1)])];
            },
            proxy: true
          }], null, false, 2082228166)
        }, [_c('div', {
          staticClass: "locale-dropdown-body"
        }, _vm._l(_setup.languagesOptions, function (language) {
          return _c('b-dropdown-item-button', {
            key: language.value,
            staticClass: "language-container",
            attrs: {
              "active": _setup.locale === language.value
            },
            on: {
              "click": function ($event) {
                return _setup.setLocale(language.value, _setup.userLanguages);
              }
            }
          }, [_vm._v(" " + _vm._s(language.title) + " "), _setup.locale === language.value ? _c('span', {
            attrs: {
              "aria-hidden": "true"
            }
          }, [_vm._v("✓")]) : _vm._e()]);
        }), 1)])], 1)];
      },
      proxy: true
    }], null, false, 271316359)
  })], 1)], 1) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };